<template>
  <ol class="inline-flex items-center mb-2">
    <li v-for="(breadcrumb, index) in breadcrumbs" :key="index">
      <div class="flex items-center">
        <template v-if="breadcrumb.to">
          <NuxtLink
            :to="breadcrumb.to"
            :disabled="breadcrumb.disabled"
            class="ml-1 text-xs sm:text-sm"
            :class="[ breadcrumb.active ? 'text-primary font-semibold' : 'text-secondary/40' ]"
          >
            {{ breadcrumb.text }}
          </NuxtLink>
        </template>

        <template v-else>
          <p class="ml-1 text-xs sm:text-sm" :class="[ breadcrumb.active ? 'text-primary font-semibold' : 'text-secondary/40' ]">
            {{ breadcrumb.text }}
          </p>
        </template>

        <span v-if="index < breadcrumbs.length - 1" class="px-3 text-secondary/30">/</span>
      </div>
    </li>
  </ol>
</template>

<script lang="ts">
export default {
  name: 'BBreadcrumbs',
}
</script>

<script setup lang="ts">
import { NuxtLink } from '#components'

const props = defineProps<{
  breadcrumbs: {
    to: string
    text: string
    active: boolean
    disabled: boolean
  }[]
}>()
</script>
